<!-- MovieOrderForm -->

<template>
  <div class="movie mt22">
    <div style="display: flex; justify-content: space-between" @click="goAddUserInfo">
      <span>请选择{{ count }}个身份信息</span>
      <van-icon class="ml8" name="arrow" style="font-size: 18px; color: #727272" />
    </div>
    <div v-for="item in identityList" :key="item.cardId" class="identity-list" @click="handleIdentityDel(item)">
      <div>
        {{ item.name }}, {{ item.mobile }}
        <div style="font-size: 14px; margin-top: 5px">
          身份证 {{ item.cardId.substr(0, 4) }} *********** {{ item.cardId.substr(item.cardId.length - 3) }}
        </div>
      </div>
      <van-icon name="cross" />
    </div>
  </div>
</template>

<script>
export default {
  name: "movie",

  props: {
    count: {
      type: Number,
      default: 0,
    },
    identityList: {
      type: Array,
    },
  },

  data() {
    return {};
  },

  created() {
    this.init();
  },

  methods: {
    init() { },

    goAddUserInfo() {
      this.$router.push("/user-center-info");
    },

    paySetup() {
      this.$emit("paySetup", this.extInfo);
    }
  }
}
</script>

<style lang="scss" scoped>
.identity-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 -10px;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
</style>